<nav id="topNav">
	<div id="topNavMenu">
		<div id="topNavMenuInner">
			<a class="topNavLink" id="topNavHome" href="/">
				<img id="topNavHomeTextImage" src="assets/images/logo.png" alt="CultureVR" />
				<span id="topNavHomeText">Home</span>
			</a>
			<!--<a href="javascript:void(0)" class="topNavLink ">
				{{'TRANS_REMOTE.TRANS_HOW_IT' |translate}}
			</a>-->
			<!--<a href="javascript:void(0)" [routerLink]="this.globalDataService.getRemoteContext()+'/'+this.translate.currentLang+'/map'"
			   class="topNavLink ">{{'TRANS_REMOTE.TRANS_MAP' |
				translate}}</a>
			<a href="javascript:void(0)" [routerLink]="this.globalDataService.getRemoteContext()+'/'+this.translate.currentLang+'/price-list'"
			   class="topNavLink ">
				{{'TRANS_REMOTE.TRANS_PRICE_LIST' |translate}}
			</a>-->
			<!--<a href="javascript:void(0)" class="topNavLink">
				{{'TRANS_REMOTE.TRANS_ABOUT' |translate}}
			</a>-->
			<!--<a href="javascript:void(0)" [routerLink]="this.globalDataService.getRemoteContext()+'/'+this.translate.currentLang+'/about-us'"
			   class="topNavLink">
				{{'TRANS_REMOTE.TRANS_ABOUT' |translate}}
			</a>-->
			<div class="termsPolicy">
				<!--<app-terms-policy></app-terms-policy>-->
			</div>
			<div id="topNavRight">
				<a href="javascript:void(0)" class="topNavLink account">
					{{getActiveLang()}}
					<fa-icon class="chevronUp" [icon]="['fas','chevron-up']"></fa-icon>
					<fa-icon class="chevronDown" [icon]="['fas','chevron-down']"></fa-icon>
					<div class="acountSettings">
						<ul>
							<ng-container *ngFor="let lang of dropDownLanguages">
								<li *ngIf="lang.value !==getActiveLang()" (click)="setLanguage(lang)">
									{{lang.value}}
								</li>
							</ng-container>
						</ul>
					</div>
				</a>
				<ng-container *ngIf="$userCurrent | async as userCurrent">
					<a href="javascript:void(0)" *ngIf="!userCurrent.username" class="topNavLink account">
						{{'TRANS_REMOTE.TRANS_LOGIN' |translate}}
						<fa-icon class="chevronUp" [icon]="['fas','chevron-up']"></fa-icon>
						<fa-icon class="chevronDown" [icon]="['fas','chevron-down']"></fa-icon>
						<div class="acountSettings">
							<ul>
								<li (click)="login()">
									as Visitor
								</li>
								<li (click)="login()">
									as Guide
								</li>
								<li (click)="login()">
									as Tour Operator
								</li>
							</ul>
						</div>
					</a>
					<a href="javascript:void(0)" *ngIf="userCurrent.username" class="topNavLink account">
						{{'TRANS_REMOTE.TRANS_PROFILE' | translate}}
						<fa-icon class="chevronUp" [icon]="['fas','chevron-up']"></fa-icon>
						<fa-icon class="chevronDown" [icon]="['fas','chevron-down']"></fa-icon>
						<div class="acountSettings">
							<ul>
								<li><a href="javascript:void(0)"
									   [routerLink]="this.globalDataService.getRemoteContext()+'/'+this.translate.currentLang+'/profile'">{{'TRANS_REMOTE.TRANS_PROFILE' | translate}}</a>
								</li>
								<!--<li>{{'TRANS_REMOTE.TRANS_SETTINGS' | translate}}</li>-->
								<li (click)="logout()">{{'TRANS_REMOTE.TRANS_LOGOUT' | translate}}</li>
							</ul>
						</div>
					</a>
					<!--<a href="javascript:void(0)" *ngIf="!userCurrent.username" class="topNavLink signUp" (click)="signUp()">
						{{'TRANS_REMOTE.TRANS_SIGN_UP' | translate}}
					</a>-->
					<a href="javascript:void(0)" class="topNavLink signUp"
					   [routerLink]="this.globalDataService.getRemoteContext()+'/'+this.translate.currentLang+'/join-a-tour'">
						Join a Tour
					</a>
					<a href="javascript:void(0)" *ngIf="userCurrent.username && this.siteId && !(siteIsBought$ | async)"
					   (click)="openPacket()"
					   class="topNavLink signUp">
						{{'TRANS_REMOTE.TRANS_BUYNOW' |translate}}
					</a>
				</ng-container>
			</div>
		</div>
	</div>
</nav>
<app-login-window *ngIf="openLoginWindow" [(loginTrigger)]="openLoginWindow"></app-login-window>
<app-signup-window *ngIf="openSignUpWindow" [(signUpTrigger)]="openSignUpWindow"></app-signup-window>